import api from '@/services/base.service'

const methods = {
  getUsuariosByZona(zonaId) {
    return api.get(`/zonas/${zonaId}/usuarios`)
  },
  getZonasByBodega(bodegaId) {
    return api.get('/zonas', { params: { bodegaId } })
  },
  quitarUsuarioZona(zonaId, usuarioId) {
    return api.delete(`/zonas/${zonaId}/usuarios/${usuarioId}`)
  },
  agregarUsuarioZona(zonaId, usuarioId) {
    return api.post(`/zonas/${zonaId}/usuarios`, {
      usuarioId,
      zonaId
    })
  },
  getZonas(bodegaId) {
    return api.get(`/zonas`, { params: { bodegaId } })
  },
  getZona(id) {
    return api.get(`/zonas/${id}`)
  },
  addZona(zona) {
    return api.post(`/zonas`, zona)
  },
  updateZona(id, zona) {
    return api.put(`/zonas/${id}`, zona)
  },
  deleteZona(id) {
    return api.delete(`/zonas/${id}`)
  },
  getTerminales(zonaId) {
    return api.get(`/zonas/${zonaId}/terminales`)
  },
  addTerminal(zonaId, terminal) {
    return api.post(`/zonas/${zonaId}/terminales`, terminal)
  },
  updateTerminal(zonaId, id, terminal) {
    return api.put(`/zonas/${zonaId}/terminales/${id}`, terminal)
  },
  deleteTerminal(zonaId, id) {
    return api.delete(`/zonas/${zonaId}/terminales/${id}`)
  },
  addUbicaciones(zonaId, ubicaciones) {
    return api.post(`/zonas/${zonaId}/ubicaciones`, ubicaciones)
  }
}

export default methods
